import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.mitteilungen';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationMitteilungenEffects {

    Mitteilungen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MITTEILUNGEN),
        mergeMap((x: ac.GetMitteilungenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMitteilungen(x.korrelation_id).pipe(
                map((result: any) => {
                    return new ac.GetMitteilungenErfolgreichAction(result, x.korrelation_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMitteilungenFehlerAction(error, x.korrelation_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungenQueryService);
        }
        return this.service;
    }
}
